import React from 'react'

const PlacementIcon = () => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_1199_20556"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="25"
        height="25"
      >
        <rect x="0.492188" y="0.5" width="24" height="24" fill="#CCCFD6" />
      </mask>
      <g mask="url(#mask0_1199_20556)">
        <path
          d="M2.49219 20.9023C2.20885 20.9023 1.97152 20.8039 1.78019 20.6071C1.58819 20.4109 1.49219 20.1676 1.49219 19.8772V18.0319C1.49219 17.451 1.63819 16.9169 1.93019 16.4296C2.22152 15.943 2.60885 15.5716 3.09219 15.3153C4.12552 14.7856 5.17552 14.3882 6.24219 14.123C7.30886 13.8585 8.39219 13.7263 9.49219 13.7263C10.5922 13.7263 11.6755 13.8585 12.7422 14.123C13.8089 14.3882 14.8589 14.7856 15.8922 15.3153C16.3755 15.5716 16.7629 15.943 17.0542 16.4296C17.3462 16.9169 17.4922 17.451 17.4922 18.0319V19.8772C17.4922 20.1676 17.3962 20.4109 17.2042 20.6071C17.0129 20.8039 16.7755 20.9023 16.4922 20.9023H2.49219ZM19.0172 20.9023C19.1672 20.7827 19.2839 20.633 19.3672 20.4533C19.4505 20.2742 19.4922 20.0736 19.4922 19.8515V17.8269C19.4922 17.0751 19.2882 16.3531 18.8802 15.6607C18.4715 14.9691 17.8922 14.3755 17.1422 13.8801C17.9922 13.9826 18.7922 14.1575 19.5422 14.4049C20.2922 14.653 20.9922 14.9565 21.6422 15.3153C22.2422 15.657 22.7005 16.037 23.0172 16.4552C23.3339 16.8742 23.4922 17.3314 23.4922 17.8269V19.8772C23.4922 20.1676 23.3962 20.4109 23.2042 20.6071C23.0129 20.8039 22.7755 20.9023 22.4922 20.9023H19.0172ZM9.49219 12.7011C8.39219 12.7011 7.45052 12.2996 6.66719 11.4966C5.88385 10.6936 5.49219 9.72823 5.49219 8.60057C5.49219 7.47292 5.88385 6.50757 6.66719 5.70454C7.45052 4.90151 8.39219 4.5 9.49219 4.5C10.5922 4.5 11.5339 4.90151 12.3172 5.70454C13.1005 6.50757 13.4922 7.47292 13.4922 8.60057C13.4922 9.72823 13.1005 10.6936 12.3172 11.4966C11.5339 12.2996 10.5922 12.7011 9.49219 12.7011ZM19.4922 8.60057C19.4922 9.72823 19.1005 10.6936 18.3172 11.4966C17.5339 12.2996 16.5922 12.7011 15.4922 12.7011C15.3089 12.7011 15.0755 12.68 14.7922 12.6376C14.5089 12.5945 14.2755 12.5474 14.0922 12.4961C14.5422 11.9494 14.8879 11.3428 15.1292 10.6765C15.3712 10.0101 15.4922 9.31817 15.4922 8.60057C15.4922 7.88297 15.3712 7.191 15.1292 6.52466C14.8879 5.85832 14.5422 5.25177 14.0922 4.70503C14.3255 4.6196 14.5589 4.5639 14.7922 4.53793C15.0255 4.51264 15.2589 4.5 15.4922 4.5C16.5922 4.5 17.5339 4.90151 18.3172 5.70454C19.1005 6.50757 19.4922 7.47292 19.4922 8.60057Z"
          fill="#CCCFD6"
        />
      </g>
    </svg>
  )
}

export default PlacementIcon
